import React from 'react';

const SeniDebuggingKontes: React.FC = () => {
  return (
    <div className="text-justify py-4 space-y-4">
      <p className="mb-4">
        Mendapatkan status <b>Wrong Answer (WA)</b> pada sistem juri tanpa mengetahui kasus uji mana yang gagal adalah salah satu momen paling menegangkan dalam kontes pemrograman. Sering kali kode bekerja sempurna pada data sampel, namun tersandung pada kondisi batas yang tak terduga.
      </p>

      <p className="mb-4">
        Para pemrogram kompetitif berpengalaman tidak mengandalkan tebakan spekulatif. Mereka menerapkan metode ilmiah yang terstruktur, salah satunya adalah teknik <b>Stress Testing</b> otomatis dengan generator data acak.
      </p>

      <h2 className="text-lg font-semibold text-gray-800 mt-6 mb-3">
        Tiga Komponen Utama Stress Testing
      </h2>
      <ol className="list-decimal pl-6 mb-6 space-y-3">
        <li>
          <strong>Solusi Lambat namun Pasti Benar (Brute Force):</strong> Menuliskan solusi sederhana berbasis pencarian menyeluruh yang diyakini 100% akurat untuk dataset berukuran kecil.
        </li>
        <li>
          <strong>Generator Kasus Uji Acak (Testcase Generator):</strong> Skrip kecil yang menghasilkan ratusan input acak dalam skala kecil secara berulang.
        </li>
        <li>
          <strong>Skrip Pembanding Otomatis:</strong> Menjalankan solusi optimal dan solusi brute force secara bersamaan, lalu membandingkan hasilnya hingga ditemukan perbedaan output pertama.
        </li>
      </ol>

      <div className="bg-amber-50 border-l-4 border-amber-400 p-4 mb-4 rounded-r-lg">
        <p className="text-gray-800 text-sm">
          <b>&quot;Menemukan kasus uji gagal terkecil (minimal counterexample) memangkas waktu pencarian bug hingga 80% dibandingkan mencoba menelusuri ratusan baris kode secara manual.&quot;</b>
        </p>
      </div>

      <h2 className="text-lg font-semibold text-gray-800 mt-6 mb-3">
        Waspadai Jebakan Overflow dan Kasus Ekstrem
      </h2>
      <p className="mb-4">
        Mayoritas kesalahan logika tersembunyi berakar pada luapan tipe data (<i>integer overflow</i>) ketika hasil perkalian melebihi kapasitas 32-bit (sehingga memerlukan <code>long long</code> di C++), kesalahan pengindeksan array bernilai nol atau kosong, serta pembagian dengan angka nol.
      </p>

      <p className="mb-4">
        Dengan membiasakan diri menulis kode yang defensif dan menguasai teknik pengujian mandiri, peserta dapat menghemat banyak waktu berharga saat kontes sesungguhnya berlangsung.
      </p>
    </div>
  );
};

export default SeniDebuggingKontes;
